<template>
    <div>
    <div class="top-bottom">
        <div class="container px-lg-5">
            <div class="px-lg-5">
                <h3>Ready for a different prespective? </h3>  
                <ul class="list-unstyled apps-store">
                    <li>
                        <a href="">
                            <img src="../assets/img/icons/googleplay.png" alt="Google Play">
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <img src="../assets/img/icons/download-apple.png" alt="App Store">
                        </a>
                    </li>
                </ul>
            </div>   
        </div>
    </div>

    <!-- Footer-->
    <footer class="footer">
        <div class="container">
            <div class="footer-content px-lg-5">
                <div class="left-nav-item">
                    <ul class="list-unstyled">
                        <li><router-link to="/about-us">About Us</router-link></li>
                        <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
                        <li><router-link to="/terms-of-service">Terms of Service</router-link></li>
                    </ul>
                    <p>© 2021 PlusMinus, All Rights Reserved.</p>
                </div>
                <div class="right-social">
                    <ul class="list-unstyled">
                        <li><a href="#"><img src="../assets/img/features/fb.png" alt=""></a></li>
                        <li><a href="#"><img src="../assets/img/features/insta.png" alt=""></a></li>
                        <li><a href="#"><img src="../assets/img/features/twitter.png" alt=""></a></li>
                    </ul>
                </div>
            </div>



            <!-- <div class="row">
                <div class="col-md-6 col-sm-12">
                    <ul class="list-inline" style="text-decoration: none;">
                        <li class="list-inline-item"><a class="social-icon text-xs-center" target="_blank" href="#"
                                style="text-decoration: none; color:white ">About Us</a></li>
                        <li class="list-inline-item"><a class="social-icon text-xs-center" target="_blank" href="#"
                                style="text-decoration: none; color:white">Privacy Policy</a></li>
                        <li class="list-inline-item"><a class="social-icon text-xs-center" target="_blank" href="#"
                                style="text-decoration: none; color:white">Terms of Service</a></li>
                    </ul>
                    <p style="text-decoration: none; color:white">© 2021 PlusMinus, All Rights Reserved.</p>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="icons" style="letter-spacing: 10px;">
                        <ul class="list-inline" style="text-decoration: none;">
                            <li class="list-inline-item"><a class="social-icon text-xs-center" target="_blank" href="#"
                                    style="text-decoration: none; color:white ">
                                <img src="images/fb.png" alt="">
                                </a></li>
                            <li class="list-inline-item"><a class="social-icon text-xs-center" target="_blank" href="#"
                                    style="text-decoration: none; color:white"><img src="images/insta.png" alt=""></a></li>
                            <li class="list-inline-item"><a class="social-icon text-xs-center" target="_blank" href="#"
                                    style="text-decoration: none; color:white"><img src="images/twitter.png" alt=""></a></li>
                        </ul>
                    </div>                    
                </div>
            </div> -->
           
        </div>



        
    </footer>
    </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"]
    }
</script>

<style>
.app-download-icon{
    padding-top:3%
}
.footer-widget{
    padding:5%
}
.footer-area{
    background-color: #214F4D;
}
.footer-title{
    color:white;
}
.footer-copyright-area{
    background-color:black;
    border-top:none !important;
}
.navigation-link{
    color:#C7C7C7;
}
.copyright-text{
    color:#C7C7C7;
    padding-top:10px;
}
.social-link-icon{
    color:white;
}
</style>
